<script lang="ts">
  // components
  import CreditRow from "@retailer/svelte/Payments/Credits/components/Row.svelte";
  import EmptyTable from "@shared/svelte/Components/EmptyTable.svelte";

  // types
  import type { Credit } from "@shared/types/Credit";

  // props
  export let credits: Credit[];

</script>

<thead class="fizz-sticky">
  <tr>
    <th>Distributor</th>
    <th>Issue Date</th>
    <th>Status</th>
    <th>Invoice</th>
    <th class="fizz-text-right">Amount</th>
  </tr>
</thead>
<tbody>
  {#if credits.length > 0}
    {#each credits as credit}
      <CreditRow {credit} />
    {/each}
  {:else}
    <tr class="fizz-text-center">
      <td colspan={8}>
        <div class="fizz-surface fizz-full-height fizz-full-width">
          <EmptyTable heading="No credit invoices">
            <p id="distributor-list" class="fizz-text-medium">
              There are no credit invoices in Provi.
            </p>
          </EmptyTable>
        </div>
      </td>
    </tr>
  {/if}
</tbody>
